import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
import thumbnailsWithBlurSchema from '@utils/validate/blocksSchemes/thumbnailsWithBlurSchema';
import mediaFullSchema from '@utils/validate/blocksSchemes//mediaFullSchema';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const categoryHeaderBlockSchema = Joi.object({
  type: Joi.string().valid('categoryHeader').required(),
  code: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  titleColor: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  descriptionColor: Joi.string().allow('', null).required(),
  images: mediaUrlSchema.required(),
  imagesWithBlur: imagesWithBlurSchema,
  videos: mediaFullSchema(true).required(),
  thumbnailsWithBlur: thumbnailsWithBlurSchema,
  ...blockAppearanceSchema
}).unknown(true);
export default categoryHeaderBlockSchema;